import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { LocationIcon } from 'components/core/location_icon';
const containerCss = "cu42a60";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const nameCss = "n1oy726e";
const Name = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(nameCss, props.className)} />;
});
const iconWrapperCss = "i188l4og";
const IconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconWrapperCss, props.className)} />;
});
const INTEGRATIONS = ['zoom_conference', 'gotomeeting_conference', 'google_conference', 'microsoft_teams_conference', 'webex_conference'];
const LocationNote = ({
  kind
}) => {
  if (INTEGRATIONS.includes(kind)) {
    return <BodyText size="medium" color={colorTextSecondary}>
        {I18n.t('publisher.event_type_editor.sections.event_details.location.conference_note')}
      </BodyText>;
  }
  return null;
};
export const Location = ({
  status,
  kind
}) => {
  if (!kind) {
    return I18n.t('publisher.scheduled_events.event_details.no_location');
  }
  return <>
      <Container>
        <IconWrapper>
          <LocationIcon useNewIcons kind={kind} />
        </IconWrapper>
        <Name>
          {I18n.t(`publisher.event_type_editor.sections.event_details.location.dropdown.${kind}.label`)}
        </Name>
      </Container>
      {status !== 'booked' && <LocationNote kind={kind} />}
    </>;
};

require("./location.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./location.js");